module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('home-footer-img', {
    attrs: {
      "imgurl": _vm.appcode,
      "text": "扫描下载APP"
    }
  }), _vm._v(" "), _c('home-footer-img', {
    attrs: {
      "imgurl": _vm.wechat,
      "text": "扫描关注公众号"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71b62b2c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/footer/HomeFooterRight.vue
// module id = 162
// module chunks = 1